__turbopack_context__.v({
  "image": "PhotoThumbnail-module__gJslyq__image",
  "infoBadge": "PhotoThumbnail-module__gJslyq__infoBadge",
  "infoButton": "PhotoThumbnail-module__gJslyq__infoButton",
  "skeleton": "PhotoThumbnail-module__gJslyq__skeleton",
  "thumbnail": "PhotoThumbnail-module__gJslyq__thumbnail",
  "thumbnailWrap": "PhotoThumbnail-module__gJslyq__thumbnailWrap",
  "tooltipContent": "PhotoThumbnail-module__gJslyq__tooltipContent",
  "videoBadge": "PhotoThumbnail-module__gJslyq__videoBadge",
});
